import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=e4c0e5a6&"
import script from "./calendar.js?vue&type=script&lang=js&"
export * from "./calendar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4c0e5a6')) {
      api.createRecord('e4c0e5a6', component.options)
    } else {
      api.reload('e4c0e5a6', component.options)
    }
    module.hot.accept("./calendar.vue?vue&type=template&id=e4c0e5a6&", function () {
      api.rerender('e4c0e5a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/calendar/calendar.vue"
export default component.exports